(() => {
  function init() {
    const main = document.querySelector('.km-calendar-main');
    if (!main || main.dataset.kcReady) return;
    main.dataset.kcReady = 'true';
    const updateLabel = () => {
      const button = main.querySelector('#ge-personalize');
      if (!button) return;
      const label = button.querySelector('span');
      const text = main.dataset.kmPersonalizeLabel;
      if (label && text && label.textContent !== text) label.textContent = text;
    };
    updateLabel();
    const observer = new MutationObserver(updateLabel);
    observer.observe(main, { childList: true, subtree: true });
    const sticky = document.querySelector('.kc-sticky-buy');
    const create = main.querySelector('#kc-create');
    if (sticky && create && 'IntersectionObserver' in window) {
      const visibility = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('kc-sticky-buy--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      visibility.observe(create);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
